import type { TourChapter } from "../types";

export const FRAMES_CHAPTER: TourChapter = {
  id: "frames",
  title: "Saved Frames",
  steps: [
    {
      id: "gallery", target: "frames.heading", title: "The gallery",
      body:
        "Every frame anyone on the team has saved from this flight, with who saved it and when. " +
        "A 360° badge means it came from a panorama.",
    },
    {
      id: "filters", target: "frames.filters", title: "Filters",
      body:
        "all, mine (saved by you), linked (attached to a POI) and broken (the thumbnail didn't " +
        "upload).",
    },
    {
      id: "jump", target: "frames.jump", title: "Jump back",
      body:
        "Takes you back to the viewer at the exact second the frame was saved, or reopens the " +
        "exact panorama view.",
    },
    {
      id: "lightbox", target: null, title: "Full size",
      body:
        "Click a frame to see it full size. From there you can download the original, delete " +
        "your own frames (admins can delete anyone's), or jump back. Click outside the picture " +
        "to close it.",
    },
    {
      id: "actions", target: "frames.actions", title: "Frame actions",
      body: "The ⋯ menu on a tile deletes without opening it. It'll ask you to confirm.",
    },
    {
      id: "broken", target: null, title: "Broken thumbnails",
      body:
        "Thumbnail missing means the preview didn't upload. The full frame might still be fine; " +
        "if it isn't, delete it and save it again from the viewer.",
    },
    {
      id: "handoff", target: null, title: "Open Offline",
      body: "Last stop: the offline library.",
      handoff: "Hit Offline in the header and we'll finish up there.",
    },
  ],
};
